import * as tslib_1 from "tslib";
import * as React from 'react';
import cn from 'astro-classname';
import BreadcrumbItem from './BreadcrumbItem';
import '../breadcrumb/index.css';
var Breadcrumb = (function (_super) {
    tslib_1.__extends(Breadcrumb, _super);
    function Breadcrumb() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Breadcrumb.prototype.render = function () {
        var _a = this.props, className = _a.className, children = _a.children, list = _a.list, prefix = _a.prefix, others = tslib_1.__rest(_a, ["className", "children", "list", "prefix"]);
        var classes = cn(className, prefix);
        return (React.createElement("div", tslib_1.__assign({ className: classes }, others),
            children,
            list && list.map(function (item, index) {
                return React.createElement(BreadcrumbItem, tslib_1.__assign({}, item, { key: index }));
            })));
    };
    Breadcrumb.defaultProps = {
        className: '',
        prefix: 'zhui-breadcrumb',
        list: []
    };
    return Breadcrumb;
}(React.Component));
export default Breadcrumb;
